import { websiteCanvasBridge } from '@dukanti/shared';

export interface CanvasOrigins {
  readonly adminOrigin: string;
  readonly storefrontOrigin: string;
}

export interface ResolveCanvasOriginsInput {
  readonly currentOrigin: string;
  readonly publicAdminUrl: string | null | undefined;
  readonly publicStorefrontUrl: string | null | undefined;
}

/**
 * Both origins come from configuration, are distinct and https (localhost
 * excepted), and this window must be the Admin one. There is no derived or
 * default origin: without a valid pair the editor shows its load error
 * instead of framing anything.
 */
export function resolveCanvasOrigins(input: ResolveCanvasOriginsInput): CanvasOrigins | null {
  if (!input.publicStorefrontUrl) return null;
  const resolved = websiteCanvasBridge.resolveOrigins({
    currentOrigin: input.currentOrigin,
    publicAdminUrl: input.publicAdminUrl,
    publicStorefrontUrl: input.publicStorefrontUrl,
    mode: 'admin-host',
  });
  return resolved.ok
    ? { adminOrigin: resolved.adminOrigin, storefrontOrigin: resolved.storefrontOrigin }
    : null;
}
